<template ref="footer">
  <div class="footer relative">
    <vs-navbar
      class="vx-navbar navbar-custom navbar-skelton fixed bottom-0 flex"
      :color="navbarColorLocal"
      :class="textColor">

      <!-- SM - OPEN SIDEBAR BUTTON -->
      <custom-icon class="useral-footer-menu-button"
                   icon="MENU"
                   color-code="#000"
                   height="25px"
                   width="25px"
                   @click.native="showSidebar"/>
<!--      <feather-icon
        class="useral-footer-menu-button"
        icon="MenuIcon"/>-->

      <vs-spacer/>

      <router-link :to="{name: 'home'}">
        <custom-icon class="useral-footer-menu-button"
                     icon="house-icon"
                     color-code="#000"
                     height="25px"
                     width="25px"/>
      </router-link>

      <vs-spacer/>

      <router-link :to="{name: 'Profile'}">
        <custom-icon class="useral-footer-menu-button"
                     icon="USER"
                     color-code="#000"
                     height="25px"
                     width="25px"/>
      </router-link>
    </vs-navbar>
  </div>
</template>

<script>
import CustomIcon from '../../../components/icon/customIcon'

export default {
  name: 'TheMobileFooter',
  components: {CustomIcon},
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  computed: {
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {
        'text-white':
            (this.navbarColor !== '#10163a' &&
              this.$store.state.theme === 'dark') ||
            (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')
      }
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth) return 'navbar-full'
    }
  },
  methods: {
    showSidebar () {
      setTimeout(() => {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }, 3)
    }
  }
}
</script>

<style lang="scss" scoped>
.vx-navbar-wrapper {
  background: transparent !important;

  .vx-navbar {
    height: 50px;
    border-top: 1px solid #03092d;
  }
}
</style>
